import React, { useContext, useState } from 'react';
import Base from './base/base';
import Forms from './forms/forms';
import Statistics from './statistics/statistics';
import { SnackbarProvider } from '../contexts/SnackbarContext';
import Users from './users/users';
import { verifyRole } from '../utils/verify-role';
import { UserRole } from '../models/user-role.model';
import { useNavigate } from 'react-router-dom';
import AccountMenu from './account-menu';
import { UserContext } from '../contexts/UserContext';
import FormGroups from './form-groups/form-groups';


function Dashboard() {
    const [currentPage, setCurrentPage] = useState('base');
    const navigate = useNavigate(); 
    const { currentUser } = useContext(UserContext);

    const renderComponent = () => {
        if (!currentUser) {
            navigate('/');
            return null;
        }

        switch (currentPage) {
            case 'base':
                return (
                    <SnackbarProvider>
                        <Base />
                    </SnackbarProvider>
                );
            case 'forms':
                return verifyRole(currentUser.role, UserRole.MAINTAINER) ? (
                    <SnackbarProvider>
                        <Forms />
                    </SnackbarProvider>
                ): null;
            case "form-groups":
                return verifyRole(currentUser.role, UserRole.MAINTAINER) ? (
                    <SnackbarProvider>
                        <FormGroups />
                    </SnackbarProvider>
                ): null
            case 'statistics':
                return verifyRole(currentUser.role, UserRole.ANALYST) ? (
                    <SnackbarProvider>
                        <Statistics />
                    </SnackbarProvider>
                ) : null;
            case 'users':
                return verifyRole(currentUser.role, UserRole.SYSADMIN) ? (
                <SnackbarProvider>
                    <Users />
                </SnackbarProvider>) : null;
            default:
                return null;
        }
    };

    return !currentUser ? null : (
        <div className="flex min-h-screen">
            <div className="w-64 bg-gray-800 text-white flex flex-col">
                <div className='flex flex-row w-full justify-center items-center'>
                    <img src='/assets/logo_textless.svg' className='h-10' alt='logo'></img>
                    <h1 className="text-2xl font-bold p-4 border-b border-gray-700">Dashboard</h1>
                </div>
                <nav className="flex-1 w-64">
                    <button
                        onClick={() => setCurrentPage('base')}
                        className="w-full text-left p-4 hover:bg-gray-700"
                    >
                        Home
                    </button>
                    {(verifyRole(currentUser.role, UserRole.MAINTAINER) ? (<button
                        onClick={() => setCurrentPage('forms')}
                        className="w-full text-left p-4 hover:bg-gray-700"
                    >
                        Forms
                    </button>) : null)}
                    {(verifyRole(currentUser.role, UserRole.MAINTAINER) ? (<button
                        onClick={() => setCurrentPage('form-groups')}
                        className="w-full text-left p-4 hover:bg-gray-700"
                    >
                        Form Groups
                    </button>) : null)}
                    {(verifyRole(currentUser.role, UserRole.ANALYST) ? (<button
                        onClick={() => setCurrentPage('statistics')}
                        className="w-full text-left p-4 hover:bg-gray-700"
                    >
                        Statistics
                    </button>) : null)}
                    {(verifyRole(currentUser.role, UserRole.SYSADMIN) ? (<button
                        onClick={() => setCurrentPage('users')}
                        className="w-full text-left p-4 hover:bg-gray-700"
                    >
                        Users
                    </button>) : null)}

                    <AccountMenu email={currentUser.email}  />
                </nav>

            </div>
            {renderComponent()}
        </div>
    );
};

export default Dashboard;
